import { defineStore } from "pinia";
import { useI18n } from "vue-i18n";
import { StorageHelper } from "@/utils/StorageHelper";
import { StorageName } from "@/utils/StorageHelper/constants";
import { watch } from "vue";
import type { AppLanguage } from "@/constants";
import type { valueOf } from "@/types";
import { i18n } from "@/i18n";

export const useLanguageStore = defineStore("languageStore", () => {
    const { locale } = useI18n();
    const localStorageHelper = new StorageHelper(StorageName.AppLanguage);

    const changeLanguage = (language: valueOf<AppLanguage>) => {
        i18n.global.locale = language as string;
    };

    watch(locale, () => {
        localStorageHelper.write(locale.value);
    });

    const initialize = async () => {
        localStorageHelper.write(locale.value);

        return Promise.resolve();
    };

    return { initialize, changeLanguage };
});
